// these week day indecies are the same in SQL week day indices -- requested by Mr.Ebrahimi
// const WeekDays = {
//   Sunday: 1,
//   Monday: 2,
//   Tuesday: 3,
//   Wednesday: 4,
//   Thursday: 5,
//   Friday: 6,
//   Saturday: 7,
// };

const WeekDays = [
  { id: 7, title: "شنبه" },
  { id: 1, title: "یکشنبه" },
  { id: 2, title: "دوشنبه" },
  { id: 3, title: "سه شنبه" },
  { id: 4, title: "چهارشنبه" },
  { id: 5, title: "پنجشنبه" },
  { id: 6, title: "جمعه" },
]

export default WeekDays;
